module.exports = __webpack_public_path__ + "img/guizhouHints_16.6b203316.jpg";